import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})

export class VersionService {
    versionNumber: string = "v20230609";
}